import { Pagination } from '@mantine/core'
import { useEffect, useRef, useState } from 'react'

import ClassList from '../../components/admin/ClassList'
import ClassStatusList from '../../components/admin/ClassStatusList'
import HeaderSection from '../../components/admin/HeaderSection'
import SaveButton from '../../components/common/SaveButton'
import AdminContentLayout from '../../components/layout/AdminContentLayout'
import AdminLayout from '../../components/layout/AdminLayout'
import CurriculumLayout from '../../components/layout/CurriculumLayout'

import { useLecturesList } from '../../api/hooks/Lectures/useLectureList'
import { useLecturesStatus } from '../../api/hooks/Lectures/useLectureStatus'
import styles from '../../styles/admin/Main.module.scss'
import { useLocation } from 'react-router-dom'

const Lectures = () => {
  const { data: requestData } = useLecturesStatus()
  const shouldResetPage = useRef(true)
  const location = useLocation()
  console.log("받아온 location ? ", location)
  const initialPage = location.state?.fromPage || 1
  const rawLevel = location.state?.level || 'level 1'
  const initialLevel = rawLevel.replace(/\D/g, '') || '1'
  const [selectedLevel, setSelectedLevel] = useState<string>(initialLevel)
  const { data: questionsData } = useLecturesList(selectedLevel)

  const [currentPage, setCurrentPage] = useState(initialPage)
  const itemsPerPage = 11

  const lectureData = questionsData?.data || []
  const startIndex = (currentPage - 1) * itemsPerPage
  const endIndex = startIndex + itemsPerPage
  const currentData = lectureData.slice(startIndex, endIndex)

  const totalPages = Math.ceil(lectureData.length / itemsPerPage)

  const [pageInput, setPageInput] = useState('')

  const handlePageChange = (page: number) => {
    setCurrentPage(page)
    setPageInput('')
  }

  const handlePageJump = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      const page = parseInt((e.target as HTMLInputElement).value)
      if (!isNaN(page) && page >= 1 && page <= totalPages) {
        setCurrentPage(page)
        setPageInput('')
      }
    }
  }

  const handleLevelChange = (level: string) => {
    setSelectedLevel(level)
    setCurrentPage(1) // 검색할 땐 1로 초기화
  }

  useEffect(() => {
    // LEVEL 변경될 때만 1페이지로 리셋
    shouldResetPage.current = true
  }, [selectedLevel])

  useEffect(() => {
    if (location.state?.level) {
      const raw = location.state.level
      const level = raw.replace(/\D/g, '') || '1'
      setSelectedLevel(level)
    }
  }, [location.state?.level])

  return (
    <AdminLayout>
      <AdminContentLayout>
        <CurriculumLayout title={'Lectures & Assignments'}>
          <HeaderSection
            selectedLevel={selectedLevel}
            onLevelChange={handleLevelChange}
            data={currentData}
            currentPage={currentPage}
          />

          <ClassList data={currentData} currentPage={currentPage} />

          {totalPages > 1 && (
            <div className={styles.paginationWrapper}>
              <Pagination
                value={currentPage}
                onChange={handlePageChange}
                total={totalPages}
                size="sm"
                withEdges={false}
                color="gray"
                classNames={{
                  control: styles.paginationControl,
                }}
              />
              <div className={styles.pageJumpWrapper}>
                <input
                  type="text"
                  inputMode="numeric"
                  value={pageInput}
                  onChange={(e) => setPageInput(e.target.value)}
                  onKeyDown={handlePageJump}
                  placeholder={String(currentPage)}
                  className={styles.pageJumpInput}
                />
                <span className={styles.pageJumpTotal}>/ {totalPages}</span>
              </div>
            </div>
          )}

          <p className={styles.textWrapper}>Class Status</p>

          <ClassStatusList data={requestData?.data || []} />
        </CurriculumLayout>
      </AdminContentLayout>
    </AdminLayout>
  )
}

export default Lectures
